import client from '../request'

const getAll = `/settings`

const get = (id) => {
  return `/settings/${id}`
}

const create = (data) => {
  return client.post('/settings', data)
}

const update = (id, data) => {
  return client.put(`/settings/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/settings/${id}`)
}

const ReviewService = {
  getAll,
  get,
  create,
  update,
  toRow,
  remove,
  toPaginate
}

export default ReviewService
